import React, { FC, memo } from 'react';
import IconsSVG from './icons.svg';

export type TIconsProps = {
  name: string;
  color?: string;
  size?: string;
  width?: string;
  height?: string;
  className?: string;
};

export const Icons: FC<TIconsProps> = memo(
  ({ name, color, size = 20, className = '', width, height }) => (
    <svg
      className={`${name} ${className}`}
      fill={color}
      stroke={color}
      width={width || size}
      height={height || size}
    >
      <use xlinkHref={`${IconsSVG}#${name}`} />
    </svg>
  ),
);
